/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAddAPhoto from '../../../../../../Icon/IconAddAPhoto';
import IconAddToPhotos from '../../../../../../Icon/IconAddToPhotos';
import IconAdjust from '../../../../../../Icon/IconAdjust';
import IconAssistant from '../../../../../../Icon/IconAssistant';
import IconAssistantPhoto from '../../../../../../Icon/IconAssistantPhoto';
import IconAudiotrack from '../../../../../../Icon/IconAudiotrack';
import IconBlurCircular from '../../../../../../Icon/IconBlurCircular';
import IconBlurLinear from '../../../../../../Icon/IconBlurLinear';
import IconBlurOff from '../../../../../../Icon/IconBlurOff';
import IconBlurOn from '../../../../../../Icon/IconBlurOn';
import IconBrightness1 from '../../../../../../Icon/IconBrightness1';
import IconBrightness2 from '../../../../../../Icon/IconBrightness2';
import IconBrightness3 from '../../../../../../Icon/IconBrightness3';
import IconBrightness4 from '../../../../../../Icon/IconBrightness4';
import IconBrightness5 from '../../../../../../Icon/IconBrightness5';
import IconBrightness6 from '../../../../../../Icon/IconBrightness6';
import IconBrightness7 from '../../../../../../Icon/IconBrightness7';
import IconBrokenImage from '../../../../../../Icon/IconBrokenImage';
import IconBrush from '../../../../../../Icon/IconBrush';
import IconBurstMode from '../../../../../../Icon/IconBurstMode';
import IconCamera from '../../../../../../Icon/IconCamera';
import IconCameraAlt from '../../../../../../Icon/IconCameraAlt';
import IconCameraFront from '../../../../../../Icon/IconCameraFront';
import IconCameraRear from '../../../../../../Icon/IconCameraRear';
import IconCameraRoll from '../../../../../../Icon/IconCameraRoll';
import IconCenterFocusStrong from '../../../../../../Icon/IconCenterFocusStrong';
import IconCenterFocusWeak from '../../../../../../Icon/IconCenterFocusWeak';
import IconCollections from '../../../../../../Icon/IconCollections';
import IconCollectionsBookmark from '../../../../../../Icon/IconCollectionsBookmark';
import IconColorLens from '../../../../../../Icon/IconColorLens';
import IconColorize from '../../../../../../Icon/IconColorize';
import IconCompare from '../../../../../../Icon/IconCompare';
import IconControlPoint from '../../../../../../Icon/IconControlPoint';
import IconControlPointDuplicate from '../../../../../../Icon/IconControlPointDuplicate';
import IconCrop169 from '../../../../../../Icon/IconCrop169';
import IconCrop from '../../../../../../Icon/IconCrop';
import IconCrop32 from '../../../../../../Icon/IconCrop32';
import IconCrop54 from '../../../../../../Icon/IconCrop54';
import IconCrop75 from '../../../../../../Icon/IconCrop75';
import IconCropDin from '../../../../../../Icon/IconCropDin';
import IconCropFree from '../../../../../../Icon/IconCropFree';
import IconCropLandscape from '../../../../../../Icon/IconCropLandscape';
import IconCropOriginal from '../../../../../../Icon/IconCropOriginal';
import IconCropPortrait from '../../../../../../Icon/IconCropPortrait';
import IconCropRotate from '../../../../../../Icon/IconCropRotate';
import IconCropSquare from '../../../../../../Icon/IconCropSquare';
import IconDehaze from '../../../../../../Icon/IconDehaze';
import IconDetails from '../../../../../../Icon/IconDetails';
import IconEdit from '../../../../../../Icon/IconEdit';
import IconExposure from '../../../../../../Icon/IconExposure';
import IconExposureNeg1 from '../../../../../../Icon/IconExposureNeg1';
import IconExposureNeg2 from '../../../../../../Icon/IconExposureNeg2';
import IconExposurePlus1 from '../../../../../../Icon/IconExposurePlus1';
import IconExposurePlus2 from '../../../../../../Icon/IconExposurePlus2';
import IconExposureZero from '../../../../../../Icon/IconExposureZero';
import IconFilter1 from '../../../../../../Icon/IconFilter1';
import IconFilter2 from '../../../../../../Icon/IconFilter2';
import IconFilter from '../../../../../../Icon/IconFilter';
import IconFilter3 from '../../../../../../Icon/IconFilter3';
import IconFilter4 from '../../../../../../Icon/IconFilter4';
import IconFilter5 from '../../../../../../Icon/IconFilter5';
import IconFilter6 from '../../../../../../Icon/IconFilter6';
import IconFilter7 from '../../../../../../Icon/IconFilter7';
import IconFilter8 from '../../../../../../Icon/IconFilter8';
import IconFilter9 from '../../../../../../Icon/IconFilter9';
import IconFilter9Plus from '../../../../../../Icon/IconFilter9Plus';
import IconFilterBAndW from '../../../../../../Icon/IconFilterBAndW';
import IconFilterCenterFocus from '../../../../../../Icon/IconFilterCenterFocus';
import IconFilterDrama from '../../../../../../Icon/IconFilterDrama';
import IconFilterFrames from '../../../../../../Icon/IconFilterFrames';
import IconFilterHdr from '../../../../../../Icon/IconFilterHdr';
import IconFilterNone from '../../../../../../Icon/IconFilterNone';
import IconFilterTiltShift from '../../../../../../Icon/IconFilterTiltShift';
import IconFilterVintage from '../../../../../../Icon/IconFilterVintage';
import IconFlare from '../../../../../../Icon/IconFlare';
import IconFlashAuto from '../../../../../../Icon/IconFlashAuto';
import IconFlashOff from '../../../../../../Icon/IconFlashOff';
import IconFlashOn from '../../../../../../Icon/IconFlashOn';
import IconFlip from '../../../../../../Icon/IconFlip';
import IconGradient from '../../../../../../Icon/IconGradient';
import IconGrain from '../../../../../../Icon/IconGrain';
import IconGridOff from '../../../../../../Icon/IconGridOff';
import IconGridOn from '../../../../../../Icon/IconGridOn';
import IconHdrOff from '../../../../../../Icon/IconHdrOff';
import IconHdrOn from '../../../../../../Icon/IconHdrOn';
import IconHdrStrong from '../../../../../../Icon/IconHdrStrong';
import IconHdrWeak from '../../../../../../Icon/IconHdrWeak';
import IconHealing from '../../../../../../Icon/IconHealing';
import IconImage from '../../../../../../Icon/IconImage';
import IconImageAspectRatio from '../../../../../../Icon/IconImageAspectRatio';
import IconIso from '../../../../../../Icon/IconIso';
import IconLandscape from '../../../../../../Icon/IconLandscape';
import IconLeakAdd from '../../../../../../Icon/IconLeakAdd';
import IconLeakRemove from '../../../../../../Icon/IconLeakRemove';
import IconLens from '../../../../../../Icon/IconLens';
import IconLinkedCamera from '../../../../../../Icon/IconLinkedCamera';
import IconLooks from '../../../../../../Icon/IconLooks';
import IconLooks3 from '../../../../../../Icon/IconLooks3';
import IconLooks4 from '../../../../../../Icon/IconLooks4';
import IconLooks5 from '../../../../../../Icon/IconLooks5';
import IconLooks6 from '../../../../../../Icon/IconLooks6';
import IconLooksOne from '../../../../../../Icon/IconLooksOne';
import IconLooksTwo from '../../../../../../Icon/IconLooksTwo';
import IconLoupe from '../../../../../../Icon/IconLoupe';
import IconMonochromePhotos from '../../../../../../Icon/IconMonochromePhotos';
import IconMovieCreation from '../../../../../../Icon/IconMovieCreation';
import IconMovieFilter from '../../../../../../Icon/IconMovieFilter';
import IconMusicNote from '../../../../../../Icon/IconMusicNote';
import IconNature from '../../../../../../Icon/IconNature';
import IconNaturePeople from '../../../../../../Icon/IconNaturePeople';
import IconNavigateBefore from '../../../../../../Icon/IconNavigateBefore';
import IconNavigateNext from '../../../../../../Icon/IconNavigateNext';
import IconPalette from '../../../../../../Icon/IconPalette';
import IconPanorama from '../../../../../../Icon/IconPanorama';
import IconPanoramaFishEye from '../../../../../../Icon/IconPanoramaFishEye';
import IconPanoramaHorizontal from '../../../../../../Icon/IconPanoramaHorizontal';
import IconPanoramaVertical from '../../../../../../Icon/IconPanoramaVertical';
import IconPanoramaWideAngle from '../../../../../../Icon/IconPanoramaWideAngle';
import IconPhoto from '../../../../../../Icon/IconPhoto';
import IconPhotoAlbum from '../../../../../../Icon/IconPhotoAlbum';
import IconPhotoCamera from '../../../../../../Icon/IconPhotoCamera';
import IconPhotoFilter from '../../../../../../Icon/IconPhotoFilter';
import IconPhotoLibrary from '../../../../../../Icon/IconPhotoLibrary';
import IconPhotoSizeSelectActual from '../../../../../../Icon/IconPhotoSizeSelectActual';
import IconPhotoSizeSelectLarge from '../../../../../../Icon/IconPhotoSizeSelectLarge';
import IconPhotoSizeSelectSmall from '../../../../../../Icon/IconPhotoSizeSelectSmall';
import IconPictureAsPdf from '../../../../../../Icon/IconPictureAsPdf';
import IconPortrait from '../../../../../../Icon/IconPortrait';
import IconRemoveRedEye from '../../../../../../Icon/IconRemoveRedEye';
import IconRotate90DegreesCcw from '../../../../../../Icon/IconRotate90DegreesCcw';
import IconRotateLeft from '../../../../../../Icon/IconRotateLeft';
import IconRotateRight from '../../../../../../Icon/IconRotateRight';
import IconSlideshow from '../../../../../../Icon/IconSlideshow';
import IconStraighten from '../../../../../../Icon/IconStraighten';
import IconStyle from '../../../../../../Icon/IconStyle';
import IconSwitchCamera from '../../../../../../Icon/IconSwitchCamera';
import IconSwitchVideo from '../../../../../../Icon/IconSwitchVideo';
import IconTagFaces from '../../../../../../Icon/IconTagFaces';
import IconTexture from '../../../../../../Icon/IconTexture';
import IconTimelapse from '../../../../../../Icon/IconTimelapse';
import IconTimer10 from '../../../../../../Icon/IconTimer10';
import IconTimer from '../../../../../../Icon/IconTimer';
import IconTimer3 from '../../../../../../Icon/IconTimer3';
import IconTimerOff from '../../../../../../Icon/IconTimerOff';
import IconTonality from '../../../../../../Icon/IconTonality';
import IconTransform from '../../../../../../Icon/IconTransform';
import IconTune from '../../../../../../Icon/IconTune';
import IconViewComfy from '../../../../../../Icon/IconViewComfy';
import IconViewCompact from '../../../../../../Icon/IconViewCompact';
import IconVignette from '../../../../../../Icon/IconVignette';
import IconWbAuto from '../../../../../../Icon/IconWbAuto';
import IconWbCloudy from '../../../../../../Icon/IconWbCloudy';
import IconWbIncandescent from '../../../../../../Icon/IconWbIncandescent';
import IconWbIridescent from '../../../../../../Icon/IconWbIridescent';
import IconWbSunny from '../../../../../../Icon/IconWbSunny';

export default function ImageIcons() {
  return (
    <div>
      <CategoryHeader>image</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAddAPhoto size="32"/>
          <FigCaption>
            IconAddAPhoto
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAddToPhotos size="32"/>
          <FigCaption>
            IconAddToPhotos
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAdjust size="32"/>
          <FigCaption>
            IconAdjust
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssistant size="32"/>
          <FigCaption>
            IconAssistant
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssistantPhoto size="32"/>
          <FigCaption>
            IconAssistantPhoto
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAudiotrack size="32"/>
          <FigCaption>
            IconAudiotrack
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBlurCircular size="32"/>
          <FigCaption>
            IconBlurCircular
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBlurLinear size="32"/>
          <FigCaption>
            IconBlurLinear
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBlurOff size="32"/>
          <FigCaption>
            IconBlurOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBlurOn size="32"/>
          <FigCaption>
            IconBlurOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightness1 size="32"/>
          <FigCaption>
            IconBrightness1
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightness2 size="32"/>
          <FigCaption>
            IconBrightness2
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightness3 size="32"/>
          <FigCaption>
            IconBrightness3
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightness4 size="32"/>
          <FigCaption>
            IconBrightness4
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightness5 size="32"/>
          <FigCaption>
            IconBrightness5
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightness6 size="32"/>
          <FigCaption>
            IconBrightness6
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightness7 size="32"/>
          <FigCaption>
            IconBrightness7
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrokenImage size="32"/>
          <FigCaption>
            IconBrokenImage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrush size="32"/>
          <FigCaption>
            IconBrush
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBurstMode size="32"/>
          <FigCaption>
            IconBurstMode
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCamera size="32"/>
          <FigCaption>
            IconCamera
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCameraAlt size="32"/>
          <FigCaption>
            IconCameraAlt
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCameraFront size="32"/>
          <FigCaption>
            IconCameraFront
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCameraRear size="32"/>
          <FigCaption>
            IconCameraRear
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCameraRoll size="32"/>
          <FigCaption>
            IconCameraRoll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCenterFocusStrong size="32"/>
          <FigCaption>
            IconCenterFocusStrong
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCenterFocusWeak size="32"/>
          <FigCaption>
            IconCenterFocusWeak
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCollections size="32"/>
          <FigCaption>
            IconCollections
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCollectionsBookmark size="32"/>
          <FigCaption>
            IconCollectionsBookmark
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconColorLens size="32"/>
          <FigCaption>
            IconColorLens
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconColorize size="32"/>
          <FigCaption>
            IconColorize
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCompare size="32"/>
          <FigCaption>
            IconCompare
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconControlPoint size="32"/>
          <FigCaption>
            IconControlPoint
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconControlPointDuplicate size="32"/>
          <FigCaption>
            IconControlPointDuplicate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCrop169 size="32"/>
          <FigCaption>
            IconCrop169
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCrop size="32"/>
          <FigCaption>
            IconCrop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCrop32 size="32"/>
          <FigCaption>
            IconCrop32
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCrop54 size="32"/>
          <FigCaption>
            IconCrop54
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCrop75 size="32"/>
          <FigCaption>
            IconCrop75
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCropDin size="32"/>
          <FigCaption>
            IconCropDin
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCropFree size="32"/>
          <FigCaption>
            IconCropFree
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCropLandscape size="32"/>
          <FigCaption>
            IconCropLandscape
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCropOriginal size="32"/>
          <FigCaption>
            IconCropOriginal
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCropPortrait size="32"/>
          <FigCaption>
            IconCropPortrait
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCropRotate size="32"/>
          <FigCaption>
            IconCropRotate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCropSquare size="32"/>
          <FigCaption>
            IconCropSquare
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDehaze size="32"/>
          <FigCaption>
            IconDehaze
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDetails size="32"/>
          <FigCaption>
            IconDetails
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEdit size="32"/>
          <FigCaption>
            IconEdit
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExposure size="32"/>
          <FigCaption>
            IconExposure
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExposureNeg1 size="32"/>
          <FigCaption>
            IconExposureNeg1
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExposureNeg2 size="32"/>
          <FigCaption>
            IconExposureNeg2
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExposurePlus1 size="32"/>
          <FigCaption>
            IconExposurePlus1
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExposurePlus2 size="32"/>
          <FigCaption>
            IconExposurePlus2
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExposureZero size="32"/>
          <FigCaption>
            IconExposureZero
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter1 size="32"/>
          <FigCaption>
            IconFilter1
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter2 size="32"/>
          <FigCaption>
            IconFilter2
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter size="32"/>
          <FigCaption>
            IconFilter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter3 size="32"/>
          <FigCaption>
            IconFilter3
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter4 size="32"/>
          <FigCaption>
            IconFilter4
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter5 size="32"/>
          <FigCaption>
            IconFilter5
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter6 size="32"/>
          <FigCaption>
            IconFilter6
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter7 size="32"/>
          <FigCaption>
            IconFilter7
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter8 size="32"/>
          <FigCaption>
            IconFilter8
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter9 size="32"/>
          <FigCaption>
            IconFilter9
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilter9Plus size="32"/>
          <FigCaption>
            IconFilter9Plus
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterBAndW size="32"/>
          <FigCaption>
            IconFilterBAndW
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterCenterFocus size="32"/>
          <FigCaption>
            IconFilterCenterFocus
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterDrama size="32"/>
          <FigCaption>
            IconFilterDrama
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterFrames size="32"/>
          <FigCaption>
            IconFilterFrames
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterHdr size="32"/>
          <FigCaption>
            IconFilterHdr
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterNone size="32"/>
          <FigCaption>
            IconFilterNone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterTiltShift size="32"/>
          <FigCaption>
            IconFilterTiltShift
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterVintage size="32"/>
          <FigCaption>
            IconFilterVintage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlare size="32"/>
          <FigCaption>
            IconFlare
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlashAuto size="32"/>
          <FigCaption>
            IconFlashAuto
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlashOff size="32"/>
          <FigCaption>
            IconFlashOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlashOn size="32"/>
          <FigCaption>
            IconFlashOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlip size="32"/>
          <FigCaption>
            IconFlip
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGradient size="32"/>
          <FigCaption>
            IconGradient
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGrain size="32"/>
          <FigCaption>
            IconGrain
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGridOff size="32"/>
          <FigCaption>
            IconGridOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGridOn size="32"/>
          <FigCaption>
            IconGridOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHdrOff size="32"/>
          <FigCaption>
            IconHdrOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHdrOn size="32"/>
          <FigCaption>
            IconHdrOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHdrStrong size="32"/>
          <FigCaption>
            IconHdrStrong
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHdrWeak size="32"/>
          <FigCaption>
            IconHdrWeak
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHealing size="32"/>
          <FigCaption>
            IconHealing
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconImage size="32"/>
          <FigCaption>
            IconImage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconImageAspectRatio size="32"/>
          <FigCaption>
            IconImageAspectRatio
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconIso size="32"/>
          <FigCaption>
            IconIso
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLandscape size="32"/>
          <FigCaption>
            IconLandscape
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLeakAdd size="32"/>
          <FigCaption>
            IconLeakAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLeakRemove size="32"/>
          <FigCaption>
            IconLeakRemove
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLens size="32"/>
          <FigCaption>
            IconLens
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLinkedCamera size="32"/>
          <FigCaption>
            IconLinkedCamera
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLooks size="32"/>
          <FigCaption>
            IconLooks
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLooks3 size="32"/>
          <FigCaption>
            IconLooks3
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLooks4 size="32"/>
          <FigCaption>
            IconLooks4
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLooks5 size="32"/>
          <FigCaption>
            IconLooks5
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLooks6 size="32"/>
          <FigCaption>
            IconLooks6
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLooksOne size="32"/>
          <FigCaption>
            IconLooksOne
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLooksTwo size="32"/>
          <FigCaption>
            IconLooksTwo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLoupe size="32"/>
          <FigCaption>
            IconLoupe
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMonochromePhotos size="32"/>
          <FigCaption>
            IconMonochromePhotos
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMovieCreation size="32"/>
          <FigCaption>
            IconMovieCreation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMovieFilter size="32"/>
          <FigCaption>
            IconMovieFilter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMusicNote size="32"/>
          <FigCaption>
            IconMusicNote
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNature size="32"/>
          <FigCaption>
            IconNature
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNaturePeople size="32"/>
          <FigCaption>
            IconNaturePeople
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNavigateBefore size="32"/>
          <FigCaption>
            IconNavigateBefore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNavigateNext size="32"/>
          <FigCaption>
            IconNavigateNext
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPalette size="32"/>
          <FigCaption>
            IconPalette
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPanorama size="32"/>
          <FigCaption>
            IconPanorama
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPanoramaFishEye size="32"/>
          <FigCaption>
            IconPanoramaFishEye
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPanoramaHorizontal size="32"/>
          <FigCaption>
            IconPanoramaHorizontal
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPanoramaVertical size="32"/>
          <FigCaption>
            IconPanoramaVertical
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPanoramaWideAngle size="32"/>
          <FigCaption>
            IconPanoramaWideAngle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoto size="32"/>
          <FigCaption>
            IconPhoto
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhotoAlbum size="32"/>
          <FigCaption>
            IconPhotoAlbum
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhotoCamera size="32"/>
          <FigCaption>
            IconPhotoCamera
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhotoFilter size="32"/>
          <FigCaption>
            IconPhotoFilter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhotoLibrary size="32"/>
          <FigCaption>
            IconPhotoLibrary
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhotoSizeSelectActual size="32"/>
          <FigCaption>
            IconPhotoSizeSelectActual
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhotoSizeSelectLarge size="32"/>
          <FigCaption>
            IconPhotoSizeSelectLarge
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhotoSizeSelectSmall size="32"/>
          <FigCaption>
            IconPhotoSizeSelectSmall
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPictureAsPdf size="32"/>
          <FigCaption>
            IconPictureAsPdf
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPortrait size="32"/>
          <FigCaption>
            IconPortrait
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRemoveRedEye size="32"/>
          <FigCaption>
            IconRemoveRedEye
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRotate90DegreesCcw size="32"/>
          <FigCaption>
            IconRotate90DegreesCcw
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRotateLeft size="32"/>
          <FigCaption>
            IconRotateLeft
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRotateRight size="32"/>
          <FigCaption>
            IconRotateRight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSlideshow size="32"/>
          <FigCaption>
            IconSlideshow
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStraighten size="32"/>
          <FigCaption>
            IconStraighten
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStyle size="32"/>
          <FigCaption>
            IconStyle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSwitchCamera size="32"/>
          <FigCaption>
            IconSwitchCamera
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSwitchVideo size="32"/>
          <FigCaption>
            IconSwitchVideo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTagFaces size="32"/>
          <FigCaption>
            IconTagFaces
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTexture size="32"/>
          <FigCaption>
            IconTexture
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTimelapse size="32"/>
          <FigCaption>
            IconTimelapse
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTimer10 size="32"/>
          <FigCaption>
            IconTimer10
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTimer size="32"/>
          <FigCaption>
            IconTimer
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTimer3 size="32"/>
          <FigCaption>
            IconTimer3
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTimerOff size="32"/>
          <FigCaption>
            IconTimerOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTonality size="32"/>
          <FigCaption>
            IconTonality
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTransform size="32"/>
          <FigCaption>
            IconTransform
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTune size="32"/>
          <FigCaption>
            IconTune
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewComfy size="32"/>
          <FigCaption>
            IconViewComfy
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewCompact size="32"/>
          <FigCaption>
            IconViewCompact
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVignette size="32"/>
          <FigCaption>
            IconVignette
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWbAuto size="32"/>
          <FigCaption>
            IconWbAuto
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWbCloudy size="32"/>
          <FigCaption>
            IconWbCloudy
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWbIncandescent size="32"/>
          <FigCaption>
            IconWbIncandescent
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWbIridescent size="32"/>
          <FigCaption>
            IconWbIridescent
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWbSunny size="32"/>
          <FigCaption>
            IconWbSunny
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/ImageIcons.js